import{useSyncExternalStore as e}from'../use-sync-external-store-shim/index.js';function o(t){return e(t.subscribe,t.getSnapshot,t.getSnapshot)}export{o as useStore};
